import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles(
  {
    imageContainer: {
      margin: 'auto',
    },
  },
  { name: 'widget-download' },
);

export default useStyle;
